import React from "react";

export default (props) => {
    return (
        <div className="tabs__content">
            {props.children}
        </div>
    )
};


